module.exports = __webpack_public_path__ + "img/portrait-anais-old.0b023de.jpg";